import { handleActions } from 'redux-actions';
import { defaultChangeEmailWidgetState } from './defaults';
import { ChangeEmailWidgetData } from './types';
import { initMyAccountPage } from '../../actions';
import {
  INITIAL_SAVE_REQUEST_META,
  makeSpecificSaveableWidgetDataMergeFunction,
  saveableWidgetRequestMetaReducer,
} from '../../widgets/utils';
import {
  setChangeEmailWidgetEmail,
  setChangeEmailWidgetPassword,
  saveChangeEmail,
  saveChangeEmailSuccess,
  saveChangeEmailFailure,
} from './actions';

const mergeChangeEmailWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(
    defaultChangeEmailWidgetState,
    widgetState => {
      return widgetState.currentData.email !== widgetState.initialData.email;
    }
  );

export default handleActions<ChangeEmailWidgetData, any>(
  {
    [initMyAccountPage.toString()]: (
      state,
      action: ReturnType<typeof initMyAccountPage>
    ) => {
      const data: ChangeEmailWidgetData['initialData'] = {
        email: action.payload.data.email ?? '',
        password: defaultChangeEmailWidgetState.initialData.password,
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        canUpdateEmail: action.payload.data.canUpdateEmail,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setChangeEmailWidgetEmail.toString()]: (
      state,
      action: ReturnType<typeof setChangeEmailWidgetEmail>
    ) =>
      mergeChangeEmailWidgetDataChange(state, {
        email: action.payload.email,
      }),
    [setChangeEmailWidgetPassword.toString()]: (
      state,
      action: ReturnType<typeof setChangeEmailWidgetPassword>
    ) =>
      mergeChangeEmailWidgetDataChange(state, {
        password: action.payload.password,
      }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: saveChangeEmail,
      successAction: saveChangeEmailSuccess,
      failureAction: saveChangeEmailFailure,
    }),
  },
  defaultChangeEmailWidgetState
);
